export function formatRevisionNumber(revision: number): string {
  return String(revision).padStart(2, '0');
}
